<app-header></app-header>
<div class="content small-head" [ngClass]="{ 'report-content-mobile': isMobile }">
  <h3>{{ "KBKReport" | translate }}</h3>
  <div class="report">
    <div class="criteria-wrapper" [ngClass]="{'criteria-mobile': isMobile}">
      <ng-container *ngIf="!isMobile;else accordion_content">
        <app-criteriaform (searchFilter)="search($event)"></app-criteriaform>
      </ng-container>
      <ng-template #accordion_content>
        <mat-accordion>
          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{'SearchCriteria' | translate}}
              </mat-panel-title>
              <!-- <mat-panel-description>
              This is a summary of the content
            </mat-panel-description> -->
            </mat-expansion-panel-header>
            <app-criteriaform (searchFilter)="search($event)"></app-criteriaform>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-template>

      <!-- (matSortChange)="sortData($event)" -->
      <mat-progress-spinner *ngIf="isLoadnig" class="spinner-margin" color="accent" [mode]="mode" diameter="100"
        [value]="value">
      </mat-progress-spinner>
      <mat-tab-group (selectedTabChange)="tabChanged($event)">
        <mat-tab label="Wyszukaj" class="tab-content">
            <!-- ### Table start ### -->
            <table mat-table matSort #mainSort="matSort"
              [ngClass]="{'mobile-table': isMobile, 'desktop-table' : !isMobile, 'hidden': isLoadnig}"
              [dataSource]="sortedData" multiTemplateDataRows class="mat-elevation-z8">
              <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName">
                  {{ "FirstName" | translate }}
                </th>
                <td mat-cell *matCellDef="let row">{{ row.firstName }}</td>
              </ng-container>
              <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName">
                  {{ "LastName" | translate }}
                </th>
                <td mat-cell *matCellDef="let row">{{ row.lastName }}</td>
              </ng-container>
              <ng-container matColumnDef="customerIdentifier">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="customerIdentifier">
                  <ng-container *ngIf="isKbw">{{ 'BirthDt' | translate}}</ng-container>
                  <ng-container *ngIf="!isKbw">{{ 'PhoneNr' | translate}}</ng-container>
                  <!-- {{ "PhoneNr" | translate }} -->
                </th>
                <td mat-cell *matCellDef="let row">{{ row.customerIdentifier}}</td>
              </ng-container>

              <ng-container matColumnDef="documentNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="documentNumber">
                  {{ "DocumentNr" | translate }}
                </th>
                <td mat-cell *matCellDef="let row">{{ row.documentNumber}}</td>
              </ng-container>
              <ng-container matColumnDef="companyName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="companyName">
                  {{ "CompanyName" | translate }}
                </th>
                <td mat-cell *matCellDef="let row">{{ row.companyName}}</td>
              </ng-container>
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row" class="actions">
                  <!-- <ng-container *ngIf="row.trainings?.length > 0;else no_trainings_template"> -->
                  <ng-container *ngIf="isMobile; else desktop_rem_btn">
                    <button mat-stroked-button color="primary" (click)="onRemoveAll($event, row)"
                      [disabled]="!(row.trainings?.length > 0)">
                      <mat-icon>delete_forever</mat-icon>
                    </button>
                  </ng-container>
                  <ng-template #desktop_rem_btn>
                    <button mat-stroked-button color="primary" (click)="onRemoveAll($event, row)"
                      [disabled]="!(row.trainings?.length > 0)">
                      <mat-icon>delete_forever</mat-icon>
                      {{ "RemoveAllTrainings" | translate }}
                    </button>
                  </ng-template>
                  <!-- </ng-container> -->
                  <ng-template #no_trainings_template>
                    <p style="font-weight: bold;">{{'NoTrainings' | translate}}</p>
                  </ng-template>
                </td>
              </ng-container>




                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" class="detail-column"
                      [attr.colspan]="columnsToDisplay.length">
                      <div class="element-detail" [@detailExpand]="
                    element == expandedElement ? 'expanded' : 'collapsed'">
                    <ng-container *ngIf="isKbw">
                      <div class="kbw-edit-wrapper">
                        <h3>{{'EditUserData' | translate}}</h3>
                        <div class="kbw-edit-form">
                          <form [formGroup]="editUserForm" (ngSubmit)="updateUser()">
                            <div>
                              <input matInput formControlName="userId" [hidden]="true">
                              <mat-form-field appearance="fill">
                                <mat-label>{{'FirstName' | translate }}</mat-label>
                                <input matInput formControlName="firstName" [errorStateMatcher]="matcher" placeholder="Wprowadź imię...">
                                <button matSuffix mat-icon-button aria-label="Clear" type="button" (click)="clearField('firstName')">
                                  <mat-icon>close</mat-icon>
                                </button>
                                <mat-error *ngIf="editUserForm.controls['firstName'].hasError('minlength') && !editUserForm.controls['firstName'].hasError('required')">
                                    {{'FieldRequiredMoreThanTwoChar' | translate }}
                                  </mat-error>
                                  <mat-error *ngIf="editUserForm.controls['firstName'].hasError('required')" [innerHtml]="'FieldRequired' | translate">
                                  </mat-error>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field appearance="fill">
                                <mat-label>{{'LastName' | translate }}</mat-label>
                                <input matInput formControlName="lastName" placeholder="Wprowadź nazwisko...">
                                <button matSuffix mat-icon-button aria-label="Clear" type="button" (click)="clearField('lastName')">
                                  <mat-icon>close</mat-icon>
                                </button>
                                <mat-error *ngIf="editUserForm.controls['lastName'].hasError('minlength') && !editUserForm.controls['lastName'].hasError('required')">
                                  {{'FieldRequiredMoreThanTwoChar' | translate }}
                                  </mat-error>
                                  <mat-error *ngIf="editUserForm.controls['lastName'].hasError('required')" [innerHtml]="'FieldRequired' | translate">
                                  </mat-error>
                              </mat-form-field>
                            </div>
                            <div>
                              <mat-form-field appearance="fill">
                                <mat-label>{{'BirthDt' | translate }}</mat-label>
                                <input matInput formControlName="customerIdentifier" type="text" (click)="picker.open()" [matDatepicker]="picker" [min]="minDate" [max]="maxDate" placeholder="Wybierz datę z kalendarza...">
                                <button matSuffix mat-icon-button aria-label="Clear" type="button" (click)="clearField('customerIdentifier')">
                                  <mat-icon>close</mat-icon>
                                </button>
                                <mat-error *ngIf="editUserForm.controls['lastName'].hasError('minlength') && !editUserForm.controls['lastName'].hasError('required')">
                                  {{'FieldRequiredMoreThanTwoChar' | translate }}
                                  </mat-error>
                                  <mat-error *ngIf="editUserForm.controls['lastName'].hasError('required')" [innerHtml]="'FieldRequired' | translate">
                                  </mat-error>
                                  <mat-datepicker touchUi #picker startView="multi-year" disabled="false"></mat-datepicker>
                              </mat-form-field>
                            </div>
                            <div class="save-data-button">
                              <button mat-raised-button color="primary" [disabled]="!editUserForm.valid">
                                <mat-icon>save</mat-icon>{{ "SaveData" | translate }}
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </ng-container>
                        <div class="detail-table">
                          <h3>{{"AllTrainings" | translate}}</h3>
                          <table class="std-table" [ngClass]="isMobile ? 'mobile-std-table' : 'desktop-std-table'">
                            <thead>
                              <tr>
                                <th>{{ "Title" | translate }}</th>
                                <th>{{ "ValidFrom" | translate }}</th>
                                <th>{{ "ValidTo" | translate }}</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngFor="let detail of element.trainings">
                                <tr>
                                  <td>
                                    <p>{{ detail.title }}</p>
                                  </td>
                                  <td>
                                    {{ detail.validFrom | date: "yyyy-MM-dd HH:mm" }}
                                  </td>
                                  <td>
                                    {{ detail.validTo | date: "yyyy-MM-dd HH:mm" }}
                                  </td>
                                  <td>
                                    <ng-container *ngIf="isMobile; else desktop_content">
                                      <!-- <button mat-raised-button color="primary"></button> -->
                                      <button mat-icon-button aria-label="Remove training" color="primary"
                                        (click)="onRemoveOne(element.userId, detail.trainingId)">
                                        <mat-icon>delete_forever</mat-icon>
                                      </button>
                                    </ng-container>
                                    <ng-template #desktop_content>
                                      <button mat-raised-button color="primary"
                                        (click)="onRemoveOne(element.userId, detail.trainingId)">
                                        <mat-icon>delete_forever</mat-icon>{{ "CancelTraining" | translate }}
                                      </button>
                                    </ng-template>
                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let element; columns: columnsToDisplay" class="element-row"
                      [class.expanded-row]="expandedElement === element"
                      (click)="onRowClicked(element)"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row" ></tr>
            </table>

          <mat-paginator [ngClass]="{'hidden' : isLoadnig}" #mainPaginator [length]="resultsLength"
            [pageSize]="pageSize"></mat-paginator>
        </mat-tab>

        <!-- ###last kbw users### -->
        <ng-container *ngIf="isKbw">
          <mat-tab label="KBW Ostatnie rejestracje" class="tab-content">
            <button class="refresh-button" mat-raised-button color="accent" type="button" (click)="refreshKbwLast()">
              <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
              Aktualizuj dane&nbsp;&nbsp;<mat-icon>refresh</mat-icon>
            </button>
            <table mat-table matSort
              [ngClass]="{'mobile-table': isMobile, 'desktop-table' : !isMobile, 'hidden': isLoadnig}"
              [dataSource]="kbwLastData" multiTemplateDataRows class="mat-elevation-z8">
              <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName">
                  {{ "FirstName" | translate }}
                </th>
                <td mat-cell *matCellDef="let row">{{ row.firstName }}</td>
              </ng-container>
              <ng-container matColumnDef="lastName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName">
                  {{ "LastName" | translate }}
                </th>
                <td mat-cell *matCellDef="let row">{{ row.lastName }}</td>
              </ng-container>
              <ng-container matColumnDef="documentNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="documentNumber">
                  {{ "DocumentNr" | translate }}
                </th>
                <td mat-cell *matCellDef="let row">{{ row.documentNumber}}</td>
              </ng-container>
              <ng-container matColumnDef="customerIdentifier">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="customerIdentifier">
                  <ng-container *ngIf="isKbw">{{ 'BirthDt' | translate}}</ng-container>
                  <ng-container *ngIf="!isKbw">{{ 'PhoneNr' | translate}}</ng-container>
                </th>
                <td mat-cell *matCellDef="let row">{{ row.customerIdentifier}}</td>
              </ng-container>
              <ng-container matColumnDef="companyName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="companyName">
                  {{ "CompanyName" | translate }}
                </th>
                <td mat-cell *matCellDef="let row">{{ row.companyName}}</td>
              </ng-container>
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row" class="actions">
                  <ng-container *ngIf="isMobile; else desktop_rem_btn_kbw">
                    <button mat-stroked-button color="primary" (click)="onRemoveAll($event, row)"
                      [disabled]="!(row.trainings?.length > 0)">
                      <mat-icon>delete_forever</mat-icon>
                    </button>
                  </ng-container>
                  <ng-template #desktop_rem_btn_kbw>
                    <button mat-stroked-button color="primary" (click)="onRemoveAll($event, row)"
                      [disabled]="!(row.trainings?.length > 0)">
                      <mat-icon>delete_forever</mat-icon>
                      {{ "RemoveAllTrainings" | translate }}
                    </button>
                  </ng-template>
                  <ng-template #no_trainings_template>
                    <p style="font-weight: bold;">{{'NoTrainings' | translate}}</p>
                  </ng-template>
                </td>
              </ng-container>
              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" class="detail-column"
                  [attr.colspan]="columnsToDisplayKbwLast.length">
                  <div class="element-detail" [@detailExpand]="
                  element == expandedElement ? 'expanded' : 'collapsed'">
                    <div class="detail-table">
                      <table class="std-table" [ngClass]="isMobile ? 'mobile-std-table' : 'desktop-std-table'">
                        <thead>
                          <tr>
                            <th>{{ "Title" | translate }}</th>
                            <th>{{ "ValidFrom" | translate }}</th>
                            <th>{{ "ValidTo" | translate }}</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngFor="let detail of element.trainings">
                            <tr>
                              <td>
                                <p>{{ detail.title }}</p>
                              </td>
                              <td>
                                {{ detail.validFrom | date: "yyyy-MM-dd HH:mm" }}
                              </td>
                              <td>
                                {{ detail.validTo | date: "yyyy-MM-dd HH:mm" }}
                              </td>
                              <td>
                                <ng-container *ngIf="isMobile; else desktop_content">
                                  <button mat-icon-button aria-label="Remove training" color="primary"
                                    (click)="onRemoveOne(element.userId, detail.trainingId)">
                                    <mat-icon>delete_forever</mat-icon>
                                  </button>
                                </ng-container>
                                <ng-template #desktop_content>
                                  <button mat-raised-button color="primary"
                                    (click)="onRemoveOne(element.userId, detail.trainingId)">
                                    <mat-icon>delete_forever</mat-icon>{{ "CancelTraining" | translate }}
                                  </button>
                                </ng-template>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columnsToDisplayKbwLast"></tr>
              <tr mat-row *matRowDef="let element; columns: columnsToDisplayKbwLast" class="element-row"
                [class.expanded-row]="expandedElement === element"
                (click)="expandedElement = expandedElement === element ? null : element"></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
            </table>
          </mat-tab>
        </ng-container>
      </mat-tab-group>
    </div>